import StudentQuizPage from "./StudentQuizPage";

const StudentDashboard = () => {
  const styles = {
    bg_style: {
      // backgroundImg
      backgroundImg: 'url(/images/bg-img.avif") no-repeat center center fixed',
      minHeight: "calc(100vh - 65px)",
      // background:'-webkit-linear-gradient(89deg, rgb(136, 12, 198) 0%, #210e25 100%)'
      // background:'-webkit-linear-gradient(89deg, hsla(280, 89%, 41%, 1) 0%, hsla(218, 57%, 37%, 1) 100%)'
    },
  };

  return (
    <div
      className="container-fluid"
      style={{ overflow: "hidden", ...styles.bg_style }}
    >
      <div className="row ">
        <div className="col-12">
          <div className="row">
            <div
              className="col-lg-9 py-4 h-v-100 overflowY-auto"
              style={{ width: "100%" }}
            >
              <StudentQuizPage />
              {/*  */}
            </div>
          </div>
        </div>
      </div>

      {/* old code part */}
    </div>
  );
};

export default StudentDashboard;
